import React from 'react';
import { ColorPalette } from './ColorPalette';
import { ColorPaletteBackground } from './ColorPaletteBackground';

export const DisplayAvatar = ({ edit, selected, avatar, listOfColors, colorStyleID, setAvatarColorProps, avatarColorProps }) => {
    return (
        <div className={'middle items-center relative justify-center flex-col flex bg-white h-100'}>
            {edit && colorStyleID !== -1 && (
                <div className='color-palette-container absolute top-0 left-0 m-1'>
                    <ColorPalette
                        avatarColorProps={avatarColorProps} setAvatarColorProps={setAvatarColorProps}
                        colorStyleID={colorStyleID}
                        listOfColors={listOfColors}
                        className='color-palette'>
                    </ColorPalette>
                </div>
            )}
            {selected ?
                (
                    <div className='background-container absolute top-0 right-0'>
                        <ColorPaletteBackground
                            avatarColorProps={avatarColorProps} setAvatarColorProps={setAvatarColorProps}
                            colorStyleID={5}>
                        </ColorPaletteBackground>
                    </div>
                )
                : null
            }
            <div className='avatar-frame bg-white w-baseAvatarFrame xs:w-xsAvatarFrame border-3 border-solid border-black'>
                {avatar}
            </div>
        </div>
    );
};
